import { Operation } from "rfc6902/diff";

import FetchFactory, {
	GetRequest,
	ModifyRequest
} from "utils/fetch/FetchRequest";

import { BlueprintInfo } from "core/blueprint/base/BlueprintService";

import { InformationBlueprint } from "./InformationBlueprintTypes";

const ENDPOINT = "/api/blueprints/information";

export default class InformationBlueprintClient {
	public static getInfo(id: number): GetRequest<BlueprintInfo> {
		return FetchFactory.get(`${ENDPOINT}/${id}`);
	}

	public static getContent(id: number): GetRequest<InformationBlueprint> {
		return FetchFactory.get(`${ENDPOINT}/${id}/content`);
	}

	public static updateContent(
		id: number,
		content: Operation[]
	): ModifyRequest<Operation[], void> {
		return {
			operation: "PATCH",
			url: `${ENDPOINT}/${id}/content`,
			body: content,
			statusCode: 200,
			callback: () => Promise.resolve()
		};
	}
}
